/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Form_TitleInputs */

const en_contact_form_title = /** @type {(inputs: Contact_Form_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Send a message`)
};

const es_contact_form_title = /** @type {(inputs: Contact_Form_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enviar un mensaje`)
};

const de_contact_form_title = /** @type {(inputs: Contact_Form_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Senden Sie eine Nachricht`)
};

const zh_contact_form_title = /** @type {(inputs: Contact_Form_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`发送消息`)
};

const ar_contact_form_title = /** @type {(inputs: Contact_Form_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أرسل رسالة`)
};

const fr_contact_form_title = /** @type {(inputs: Contact_Form_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Envoyer un message`)
};

const vi_contact_form_title = /** @type {(inputs: Contact_Form_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gửi tin nhắn`)
};

const sw_contact_form_title = /** @type {(inputs: Contact_Form_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tuma ujumbe`)
};

const th_contact_form_title = /** @type {(inputs: Contact_Form_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ส่งข้อความ`)
};

const bs_contact_form_title = /** @type {(inputs: Contact_Form_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pošaljite poruku`)
};

const ja_contact_form_title = /** @type {(inputs: Contact_Form_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メッセージを送信する`)
};

const ko_contact_form_title = /** @type {(inputs: Contact_Form_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`메시지 보내기`)
};

const pt_contact_form_title = /** @type {(inputs: Contact_Form_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enviar mensagem`)
};

const it_contact_form_title = /** @type {(inputs: Contact_Form_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invia un messaggio`)
};

const sv_contact_form_title = /** @type {(inputs: Contact_Form_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skicka ett meddelande`)
};

const nl_contact_form_title = /** @type {(inputs: Contact_Form_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bericht versturen`)
};

const da_contact_form_title = /** @type {(inputs: Contact_Form_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Send en besked`)
};

const nb_contact_form_title = /** @type {(inputs: Contact_Form_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Send en melding`)
};

const fi_contact_form_title = /** @type {(inputs: Contact_Form_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lähetä viesti`)
};

const pl_contact_form_title = /** @type {(inputs: Contact_Form_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wyślij wiadomość`)
};

const ru_contact_form_title = /** @type {(inputs: Contact_Form_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отправить сообщение`)
};

const tr_contact_form_title = /** @type {(inputs: Contact_Form_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bir mesaj gönder`)
};

const hi_contact_form_title = /** @type {(inputs: Contact_Form_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`संदेश भेजें`)
};

const id_contact_form_title = /** @type {(inputs: Contact_Form_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kirim pesan`)
};

const ms_contact_form_title = /** @type {(inputs: Contact_Form_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hantar mesej`)
};

const cs_contact_form_title = /** @type {(inputs: Contact_Form_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poslat zprávu`)
};

const el_contact_form_title = /** @type {(inputs: Contact_Form_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Αποστολή μηνύματος`)
};

const he_contact_form_title = /** @type {(inputs: Contact_Form_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`שלחו הודעה`)
};

const af_contact_form_title = /** @type {(inputs: Contact_Form_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stuur 'n boodskap`)
};

const hu_contact_form_title = /** @type {(inputs: Contact_Form_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Üzenet küldése`)
};

/**
* | output |
* | --- |
* | "Send a message" |
*
* @param {Contact_Form_TitleInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const contact_form_title = /** @type {((inputs?: Contact_Form_TitleInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Form_TitleInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_contact_form_title(inputs)
	if (locale === "de") return de_contact_form_title(inputs)
	if (locale === "zh") return zh_contact_form_title(inputs)
	if (locale === "ar") return ar_contact_form_title(inputs)
	if (locale === "fr") return fr_contact_form_title(inputs)
	if (locale === "vi") return vi_contact_form_title(inputs)
	if (locale === "sw") return sw_contact_form_title(inputs)
	if (locale === "th") return th_contact_form_title(inputs)
	if (locale === "bs") return bs_contact_form_title(inputs)
	if (locale === "ja") return ja_contact_form_title(inputs)
	if (locale === "ko") return ko_contact_form_title(inputs)
	if (locale === "pt") return pt_contact_form_title(inputs)
	if (locale === "it") return it_contact_form_title(inputs)
	if (locale === "sv") return sv_contact_form_title(inputs)
	if (locale === "nl") return nl_contact_form_title(inputs)
	if (locale === "da") return da_contact_form_title(inputs)
	if (locale === "nb") return nb_contact_form_title(inputs)
	if (locale === "fi") return fi_contact_form_title(inputs)
	if (locale === "pl") return pl_contact_form_title(inputs)
	if (locale === "ru") return ru_contact_form_title(inputs)
	if (locale === "tr") return tr_contact_form_title(inputs)
	if (locale === "hi") return hi_contact_form_title(inputs)
	if (locale === "id") return id_contact_form_title(inputs)
	if (locale === "ms") return ms_contact_form_title(inputs)
	if (locale === "cs") return cs_contact_form_title(inputs)
	if (locale === "el") return el_contact_form_title(inputs)
	if (locale === "he") return he_contact_form_title(inputs)
	if (locale === "af") return af_contact_form_title(inputs)
	if (locale === "hu") return hu_contact_form_title(inputs)
	return en_contact_form_title(inputs)
});